const initialState = {careplan: {}}

export const careplan = (state = initialState, action) => {
	switch (action.type) {
  	case 'SET_CARE_PLAN':
      return {careplan: action.payload}; 
  }
  return state
}


